import {Routes, Route, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {LicencesList} from './components/LicencesList'
import {LicencesForm} from './components/LicencesForm'
import { LicencesViewList } from './components/LicencesViewList'

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Arteco Admin GUI',
    path: '',
    isSeparator: false,
    isActive: false,
    disableLink: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const breadcrumbs_with_lista: Array<PageLink> = [
  {
    title: 'Arteco Admin GUI',
    path: '',
    isSeparator: false,
    isActive: false,
    disableLink: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Lista Licenze',
    path: '/licences',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const LicencesRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs}>Lista pacchetti</PageTitle>
          <LicencesList />
        </>
      }
    ></Route>
    <Route
      path='add'
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs_with_lista}>Nuovo pacchetto</PageTitle>
          <LicencesForm />
        </>
      }
    />
    <Route
      path='edit/:id'
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs_with_lista}>Modifica pacchetto</PageTitle>
          <LicencesForm />
        </>
      }
    />
    <Route
      path='view/:id'
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs_with_lista}>Visualizza licenze</PageTitle>
          <LicencesViewList />
        </>
      }
    />
    <Route path='*' element={<Navigate to='/error/404' />} />
  </Routes>
)

export {LicencesRoutes}
